import React from 'react';
import { Layout } from 'antd';
import BacklinksForm from '../BacklinksForm';
import BacklinksWrapper from '../BacklinksWrapper';
import WebsiteIndexEntryTabs from '../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs';


const { Content } = Layout;


export default function BacklinksPage() {
    return (
        <Content className="general-layout-content">
            <BacklinksForm />
            <WebsiteIndexEntryTabs>
                <BacklinksWrapper />
            </WebsiteIndexEntryTabs>
        </Content>
    );
}
